<mat-dialog-content class="d-felx">

    <h1>Agregar dispositivos</h1>

    <form [formGroup]="devicesForm" (ngSubmit)="devicesForm.valid?saveDevices(devicesForm.value):errorMessage()"
        enctype="multipart/form-data" autocomplete="off">


        <div class='row-item'>
            <div style='width:100%;'>
                <combos [control]="devicesForm.get('equipmentId')" [configuration]='combosConfigEquipment'
                    [reloadCombo]='reloadComboEquipment' [required]="true" [filter]="true" (changeOptionDataComplete)="selectEquipmentId($event)">
                </combos>
            </div>
        </div>
        
        <div class='row-item'>
            <div style='width:100%;'>
                <combos [control]="devicesForm.get('userId')" [configuration]='combosConfigUsers'
                    [reloadCombo]='reloadComboUsers' [required]="true" [filter]="true">
                </combos>
            </div>
        </div>
        <div class='row-item'>
            <mat-form-field>
                <mat-label>Identificador</mat-label>
                <input autocomplete="off" type="text" formControlName='uniqueId' matInput #identifider
                    maxlength="255" placeholder="Identificador" required>
                <mat-hint>{{identifider.value.length}}/255</mat-hint>
                <mat-error>Campo requerido</mat-error>
            </mat-form-field>
        </div>

        <div class='row-item'>
            <mat-form-field>
                <mat-label>Teléfono</mat-label>
                <input autocomplete="off" type="text" formControlName='phone' matInput #phone
                    maxlength="255" placeholder="Teléfono">
                <mat-hint>{{phone.value.length}}/255</mat-hint>
            </mat-form-field>
        </div>

        <div class='row-item'>
            <mat-form-field>
                <mat-label>Modelo</mat-label>
                <input autocomplete="off" type="text" formControlName='model' matInput #model
                    maxlength="255" placeholder="Modelo">
                <mat-hint>{{model.value.length}}/255</mat-hint>
            </mat-form-field>
        </div>

        <div class='row-item'>
            <mat-form-field>
                <mat-label>Límite de velocidad</mat-label>
                <input autocomplete="off" type="number" formControlName='speedLimit' matInput #speedLimit
                    min="0" max="500" placeholder="Límite de velocidad">
                <mat-hint>Velocidad en km/h</mat-hint>
            </mat-form-field>
        </div>

        <div class='row-item'>
            <mat-form-field>
                <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
                <input autocomplete="off" type="text" appThousandSeparator formControlName='totalDistance' matInput #totalDistance
                    min="0" placeholder="Medidor actual (horas/km/ciclos)">
                <mat-hint>Valor actual del medidor</mat-hint>
            </mat-form-field>
        </div>

        <div class="col-12 text-center">
            <button  style="width: 70%; margin: 15px 0 10px 0;" color="primary" class="button-save mat-elevation-z5"
              mat-raised-button type="submit">
              Guardar
            </button>
          </div>
    </form>

</mat-dialog-content>